export default "__VITE_ASSET__B7LP9OSm__"